// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_j2-0";
export var buttonContainer = "_j2-3";
export var cancelButton = "_j2-4";
export var headerSection = "_j2-6";
export var headerTitle = "_j2-9";
export var messageSideLeft = "_j2-1";
export var messageSideRight = "_j2-2";
export var orderNumberContainer = "_j2-7";
export var orderNumberLabel = "_j2-8";
export var submitButton = "_j2-5";